export default __webpack_public_path__ + "static/media/facebook.c2357618.svg";